module.exports = __webpack_public_path__ + "media/A60.ca12afb0.mp3";